<template>
    <div id='app-main-container'>
        <div v-if='route == "itim_shop"' class='itim-shop-container'>
            <Header v-if='show_header' :updated_cart_watcher='updated_cart_watcher' :login_changed='login_changed' />
            <div class="main-body">
                <router-view :key="$route.fullPath" class="page-content" @updatedCartListener='updatedCartListener' :popstate_event='popstate_event' v-bind:user_info="user_info" @loggedInListener='loggedIn'/>
            </div>

            <Footer v-show='show_footer'/>
        </div>

        <div v-if='route == "admin_control_panel"' class='admin-control-panel-container'>
            <AdminSideBar v-show='show_admin_side_bar' v-if="admin_logged_in" :page_name='page_name' :menu_expanded='admin_side_menu_expanded' @selectedMenuOptionListener="getPageTitle"/>
            <div class='admin-control-inner-wrapper'>
                <AdminTopBar v-show='show_admin_top_bar' v-if="admin_logged_in" :admin_user_info="admin_user_info" :page_title="page_title"/>
                <div class="admin-control-panel-body" :class="{'body-no-padding' : !show_admin_side_bar}">
                    <router-view :key="$route.fullPath" class="page-content" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
	import Header from '@/ecom/components/navigation/Header'
	import Footer from '@/ecom/components/footer/Footer'
    import AdminSideBar from '@/ecom_cms/components/navigation/AdminSideBar.vue';
    import AdminTopBar from '@/ecom_cms/components/navigation/AdminTopBar.vue';
    import {checkAuth, setMetaTags, formatUrlForCachedFiles, checkOmetriaLoaded} from "@/global/modules/functions.js";
    import { computed } from 'vue'

    export default {
        name: 'App',
        components : {Header, Footer, AdminSideBar, AdminTopBar},
        provide() {
            return {
                mobile_mode: computed(() => this.mobile_mode) //Inject to all children components
            }
        },
        data() {
            return {
                updated_cart_watcher: null,
                show_top_navigation: true,
                show_footer: true,
                route: 'itim_shop',
                admin_logged_in: false,
                admin_user_info: null,
                page_title: '',
                page_name: '',
                admin_side_menu_expanded: true,
                popstate_event: null,
                wineclub: false,
                subscription_type: '',
                show_admin_top_bar: true,
                show_admin_side_bar: true,
                show_wine_club_header: true,
                current_route: {},
                login_changed: null,
                screen_size_check_timeout: null,
                mobile_mode: false,
                user_info: null
            }
        },
        methods:{
            updatedCartListener(){
               this.updated_cart_watcher = +new Date();
            },
            setTheme(theme){
                document.documentElement.className = theme;
            },
            async checkAdminAccessTemp() {
                let response = await fetch(`/api/admin-access-check-temp`, {
                    method: 'GET',
                    credentials: 'include'
                });

                let results = await checkAuth(response);
                
                if (response.status === 200){
                    if(!results){
                        window.location.href = '/';
                    }
                }
            },
            async checkAdminAccess() {
                let response = await fetch(`/api/userrole-access-check`, {
                    method: 'GET',
                    credentials: 'include'
                });

                let results = await checkAuth(response);
                
                if (response.status === 200){
                    this.admin_logged_in = results.is_logged_in;
                    this.admin_user_info = results;
                }
            },
            getPageTitle(title) {
                this.page_title = title;
            },
            loggedIn(){
                this.login_changed = +new Date();
            },
            CheckMobileMode(){
            let app_container = document.getElementById('app-main-container');
                if(typeof app_container !== 'undefined'){
                    new ResizeObserver(()=>{
                        clearTimeout(this.screen_size_check_timeout);

                        this.screen_size_check_timeout = setTimeout(() => { //Set timeout to stop ResizeObserver loop completed with undelivered notifications error
                            if(app_container.clientWidth <= 768){
                                this.mobile_mode = true;
                            }
                            else{
                                this.mobile_mode = false;
                            }
                        }, 1);
                    }).observe(app_container);
                }
            },
            async getUserInfo() {
                let response = await fetch(`/api/user`, {
                    method: 'GET',
                    credentials: 'include'
                });

                let results = await checkAuth(response);
                
                if (response.status === 200){
                    this.user_info = results.user_details;
                }
            },
            async trackOtherPages(to) {
                try{
                    let formatted_route = formatUrlForCachedFiles(to.path);
                    const response = await fetch(`/cached_routes/${formatted_route}.json`);

                    if (!response.ok){
                        throw new Error('Route not found');
                    }

                    const route = await response.json();
                    if(route.type != 'plp' && route.type != 'pdp' && checkOmetriaLoaded()){
                        if(to.path.includes('/home')) {
                            window.ometria.init('homepage', null, '501')
                        } else {
                            window.ometria.init('other', null, '501')
                        }
                    }
                    return;
                }
                catch(e){
           
                }
            }
        },
        watch: {
            $route(to, from) {
                this.current_route = to;

                // window.scrollTo(0,0);
                let pages = ['Product', 'Products'];
                if(!pages.includes(to.name)) {
                    setMetaTags('Saturday Kitchen', 'Saturday Kitchen', '');
                }
                
                this.show_header = true;
                let hide_header = ['AdminControlPanel'];
                let hide_top_banner = ['AdminControlPanel'];
  
                if (hide_header.includes(to.name)) {
                    this.show_top_navigation = false;
                    this.show_footer = false;
                }

                if (hide_top_banner.includes(to.name)) {
                    this.show_top_navigation = false;
                    this.show_footer = false;
                }

                 if(to.path == '/wine-club' || to.path == '/wine-club/' || to.path == '/wine-club/send-a-gift' || to.path == '/wine-club/send-a-gift'  || to.path == '/'){
                    this.show_header = false;
                }

                this.wineclub = false;


                if(to.path.includes('/admin/')) {
                    this.page_name = to.name;

                    if(to.name == 'Page Builder'){ //On page builder auto shrink sidebar
                        this.admin_side_menu_expanded = false;
                        this.show_admin_top_bar = false;
                        this.show_admin_side_bar = false;
                    }
                    else{
                         this.admin_side_menu_expanded = true;
                        this.show_admin_top_bar = true;
                        this.show_admin_side_bar = true;
                    }

                }

                if(!to.path.includes('/admin/')) {
                    this.trackOtherPages(to);
                }
            }
        },
        beforeMount() {
            window.onpopstate = (event) =>{ //Loading page from a back button event
                this.popstate_event = event;
                if(event){
                    return;
                }
            }

            if(window.location.pathname.includes("/admin/")){
                this.setTheme('admin');
                this.route = 'admin_control_panel';
                this.checkAdminAccessTemp();
            } 
            else{
                this.setTheme('itim_shop');
            }
        },
        mounted() {
            this.CheckMobileMode();
            this.getUserInfo();
            this.checkAdminAccess();
        },
    }
</script>

<style lang="scss">
.itim-shop-container{
	display: flex;
	flex-direction: column;
	min-height: 100dvh;
    overflow-x: clip; 
}

.main-body {
	flex: 1 0 auto;
	overflow-x: clip; //Hide scroll bar x without adding an extra y scrollbar
}

.admin-control-panel-container{
    display: flex;
    background-color: var(--background-colour);
    overflow-x: clip;
    font-family: var(--cms-font-family);
}

.admin-control-panel-body{
    padding: 0px 30px;
    flex-grow: 1;
}

.admin-control-panel-body.body-no-padding{
    padding: 0px !important;
}

.admin-control-inner-wrapper{
    flex-grow: 1;
    display: flex;
    flex-direction: column;
}
</style>
